import React, { useEffect,useState } from 'react'
import "./UpdateWebCheckIn.css"
import prevIcon from "../../../assets/icons/coloredPrev.svg";
import {useNavigate,useLocation} from "react-router-dom";
import TravellerCard from './UpdateTravellerCard/UpdateTravellerCard';
import axios from 'axios';
import { toast } from 'react-toastify';
import useAuth from "../../../customHooks/useAuth";
import { baseUrl } from '../../../common/baseUrl';
import PageLoader from '../../components/PageLoader/PageLoader';
import axiosInstance from '../../../axiosInstance/axiosInstance';
 

export default function UpdateWebCheckIn() {

  const navigate = useNavigate();
  const location = useLocation();


  const bookingId = location.state?.bookingId || "";
  const hotelId = location.state?.hotelId || "";
  const userId = location.state?.userId || "";
  
  const checkInDate = location.state?.checkInDate || "";
  const checkOutDate = location.state?.checkOutDate || "";

  const guests = location.state?.guests || [];
  const bookedRooms = location.state?.bookedRooms || [];
  const submitGuests = location.state?.subguests || [];

  const [submittedGuests,setSubmittedGuests] = useState([]);

  const restData = location.state?.webCheckin || {};
  const tags = location.state?.tagData || [];
  const timeArrival = location.state?.timeArrival || "";

  console.log("Tags : ",tags);
 
  

  useAuth();

  const [isLoading,setIsLoading] = useState(false);


 
  // Check If Booking Id HotelId are there or not
  useEffect(()=>{
      const checkData = ()=>{
        if(bookingId==="" || hotelId===""  ){
          navigate("/bookings");
        }
      }
      checkData();
  },[]);
 
  // Move Back Icon
  const MoveBack =()=>{
    navigate("/bookings",{state : {activeRequests : "requests"}});
  };

 


  // CheckIn Request for Each Room
  const handleSubmit = async(index)=>{
    try{
      setIsLoading(true);
      if(guests[index].length<=0){
        toast.error("Atleast One Guest Require in a Room");
        return;
      }

      if(!guests[index].some((guest) => !guest.is_minor)){
        toast.error("Each room must have at least one adult (18+).");
        return;
      }


      let fetchedUsersData;
      try {
      
        const response = await axiosInstance.get(`/api/v1/users`);
        fetchedUsersData = response.data.data;
      
      } catch (fetchError) {
        console.log(fetchError);
        toast.error("Failed to load users data");
        return; // Exit if we can't load user data
      }




      const finalData = guests.map((room) =>
      room.map((guest) => {
        // Minor: no contact-based matching; carry only the name.
        if (guest.is_minor) {
          return {
            name: guest.name,
            is_minor: true,
            contact: null,
            verification_id: "",
            email: "",
            address: "",
          };
        }

        // Find the matching user in usersData based on contact
        const matchedGuest = fetchedUsersData.find((user) => user.contact === guest.contact);

        // If there's a matched guest, update guest with the matching user's id, else return guest unchanged
        if (matchedGuest) {
          
          // Explicitly create a new object with user_id added
          if(matchedGuest.verification_id===""){
            let guestWithId = {
              user_id: matchedGuest.id,
              verification_id : guest.verification_id,
              name : guest.name,
              email : guest.email,
              address : guest.address
            }
            return guestWithId
          }
          return {
            user_id: matchedGuest.id,
            verification_id : guest.verification_id,
            name : guest.name,
            email : guest.email,
            address : guest.address
          };
        } else {
          let guestData = {
            name : guest.name,
            contact : guest.contact,
            verification_id : guest.verification_id,
            email : guest.email,
            address : guest.address
          }
          return guestData; // Return guest unchanged if no match
        
        }
      })
      );

      const passData = {
        guest_details : finalData[index],
        checkin_date : checkInDate,
        number_of_guests : finalData[index].length,
        checkout_date :  checkOutDate,
      }

      try{
        const response = await axiosInstance.put(`/api/v1/users/${userId}/bookings/${bookingId}/booked-rooms/${bookedRooms[index].bookedRoomId}/guest-requests/web-checkin`,passData);

        toast.success("Web CheckIn Request Updated Successfully");

      }catch(error){
        toast.error(error.response.data.message);
        console.log(error);
      }
    }catch(error){
      console.log(error);
    }
    finally{
      setIsLoading(false)
    }
  }

  // Cancel The Check In For Declined_Hotel
  const declinedHotel = ()=>{
    toast.error("Check In Will Be Directly Available at Hotel Premises")
  }

 
 
  const handleNext = () => {
    try {
      // Validation — minors only need a name; adults need full identity details.
      const isValid = guests.every((group) => {
        if (!group.length) return true; // Skip empty groups

        return group.every((guest) => {
          if (guest.is_minor) {
            return !!guest.name?.trim();
          }

          const verificationIds = guest.verification_id
            ?.split(",")
            .map((id) => id.trim())
            .filter(Boolean);

          return (
            guest.name?.trim() &&
            guest.contact &&
            guest.email?.trim() &&
            guest.address?.trim() &&
            verificationIds.length === 2
          );
        });
      });

      if (!isValid) {
        toast.error("Details are missing");
        return;
      }

      // Each occupied room must have at least one adult (18+).
      const everyRoomHasAdult = guests.every((group) => {
        if (!group.length) return true; // Skip empty rooms
        return group.some((guest) => !guest.is_minor);
      });

      if (!everyRoomHasAdult) {
        toast.error("Each room must have at least one adult (18+).");
        return;
      }

      if (guests.every(group => group.length === 0)) {
        toast.error("Please enter at least one guest to proceed.");
        return;
      }
      navigate("/updateWebCheckinTags", {
        state: {
          hotelId,
          bookingId,
          checkInDate,
          checkOutDate,
          guests,
          tags,
          bookedRooms,
          timeArrival: eta, // Pass the expected arrival time to the next page
        },
      });
      return;
    } catch (error) {
      console.log(error);
    }
  };
  
    
  const [eta, setEta] = useState(timeArrival || ""); // State for expected arrival time
  
  const handleChangeEta = (e) => {
    setEta(e.target.value);
  };

  console.log("Time Arrival : ",eta);
 
  return (
    <>
      {isLoading && <PageLoader/>}
      <div className="web-checkIn">
        {/* Header */}
        <div className="web-checkIn-header">
          <div className="web-checkIn-content">
            <div className="prevIcon">
              <img src={prevIcon} alt="" onClick={MoveBack} />
            </div>
            <div className='webCheckIn-data'>
              <h6>Traveller Details</h6>
            </div>
          </div>
        </div>

        {/* Travel Cards */}
        <div className='traveller-details'>
          <div className='traveller-header'>
            <h4>
              Who all will be visiting?
            </h4>
          </div>

          {/* Traveller Card Without Name */}
          {bookedRooms.map((room,index)=>(
            <div key={index} >
              <TravellerCard
                key = {room.id}
                bookedRoomId = {room.bookedRoomId}
                userId = {userId}
                bookingId = {bookingId}
                hotelId = {hotelId}     
                guests = {guests}
                rno = {index}
                bookedRooms =  {bookedRooms}
                submitGuests = {submitGuests}
                checkInDate = {checkInDate}
                checkOutDate = {checkOutDate}
                count = {index+1}
                tags = {tags}
                timeArrival = {eta}
              />
            </div>
          ))}
  
        </div>

        {/* Expected time arrival */}
        <div className="eta-wrapper">
          <div className="eta">
            <label className="eta-label">Expected arrival time</label>

            <div className="eta-row">
              <div className="eta-field eta-time">
                <span className="eta-icon">
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
                    <circle
                      cx="12"
                      cy="12"
                      r="8.5"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    />
                    <path
                      d="M12 7.5V12L15 14"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>

                <input
                  type="datetime-local"
                  name="arrivalDateTime"
                  value={eta}
                  onChange={handleChangeEta}
                  className="eta-input"
                />
              </div>
            </div>
          </div>
        </div>


        {/* Guest Tip */}
        <div className="guest-tip-wrapper">
          <div className="guest-tip">
            <span className="guest-tip-icon">💡</span>

            <div className="guest-tip-text">
              Tap the "Add Guest" to upload each guest's ID.
            </div>
          </div>
        </div>

        {/* Next Button */}
        <div className='checkin-footer'>
          <button className='checkin-next-btn' onClick={()=>handleNext()}>
            Next
          </button>
        </div>

      </div>
    </>
  )
}